import React from 'react';
import { ErrorType } from '../api/ErrorNormalizer';
import ErrorOverlay from '../components/Error/ErrorOverlay';
import { wrapComponentDisplayName } from '../lib/componentDisplayName';
import redirectToLogin from './redirectToLogin';

interface IWithAuthErrorOverlay {
  showAuthErrorOverlay(): void;
}

interface IWithAuthErrorOverlayState {
  showOverlay: boolean;
}

function withAuthErrorOverlay<P extends React.ReactNode>() {
  return function (WrappedComponent: React.ComponentType<P>) {
    class WithAuthErrorOverlay extends React.Component<
      P,
      IWithAuthErrorOverlayState
    > {
      static displayName = wrapComponentDisplayName(
        WrappedComponent,
        'withAuthErrorOverlay',
      );

      state = {
        showOverlay: false,
        onAuthorize: null,
      };

      showAuthErrorOverlay = () => {
        this.setState({
          showOverlay: true,
        });
      };

      handleAuthorize = () => {
        redirectToLogin();
      };

      render() {
        const { showOverlay } = this.state;

        if (showOverlay) {
          return (
            <ErrorOverlay
              errorType={ErrorType.UNAUTHORIZED}
              onAuthorize={this.handleAuthorize}
            />
          );
        }

        return (
          <WrappedComponent
            {...this.props}
            showAuthErrorOverlay={this.showAuthErrorOverlay}
          />
        );
      }
    }

    return WithAuthErrorOverlay;
  };
}

export { IWithAuthErrorOverlay };

export default withAuthErrorOverlay;
